export interface Article {
  id: string;
  title: string;
  cover: string;
  excerpt: string;
  content: string;
  author: string;
  publishDate: string;
  category: string;
  tags: string[];
  readTime: number;
}

export const articles: Article[] = [
  {
    id: 'a001',
    title: '2026年在线视频行业趋势分析：内容为王的时代已来',
    cover: 'https://readdy.ai/api/search-image?query=Modern%20digital%20content%20creation%20workspace%20with%20multiple%20screens%20showing%20video%20analytics%20and%20charts%2C%20professional%20studio%20setup%2C%20warm%20ambient%20lighting%2C%20clean%20and%20modern%20aesthetic%2C%20cinematic%20workspace%20photography&width=1200&height=600&seq=article-cover-001&orientation=landscape',
    excerpt: '随着5G网络的普及和短视频平台的崛起，在线视频行业正在经历前所未有的变革。本文将从多个维度分析2026年的行业趋势。',
    content: `<p>2026年，在线视频行业进入了全新的发展阶段。随着5G网络的全面覆盖和AI技术的深度应用，视频内容的生产、分发和消费方式都发生了根本性的变化。</p>

<h2>一、短视频持续主导流量入口</h2>
<p>短视频依然是流量最大的内容形态。数据显示，2026年上半年，短视频用户日均使用时长达到128分钟，同比增长15%。短视频已经不仅仅是一种娱乐方式，更成为了信息获取、知识学习和社交互动的主要渠道。</p>

<h2>二、长视频平台寻求差异化突围</h2>
<p>面对短视频的冲击，长视频平台开始寻找差异化发展路径。一方面，加大原创内容投入，打造独家IP；另一方面，通过互动剧、VR观影等新技术提升用户体验，建立竞争壁垒。</p>

<h2>三、AI赋能内容创作与推荐</h2>
<p>AI技术在视频行业的应用越来越深入。从智能剪辑、自动字幕到个性化推荐，AI正在重新定义内容生产的效率和精准度。2026年，超过60%的视频内容在制作过程中使用了AI辅助工具。</p>

<h2>四、中老年用户成为新增长点</h2>
<p>随着人口老龄化趋势加剧，中老年用户群体正在成为视频平台的新增长引擎。广场舞教学、养生保健、戏曲欣赏等内容需求旺盛，糖豆视频等专注中老年市场的平台用户增长迅猛。</p>

<h2>五、多平台聚合成为用户刚需</h2>
<p>用户不再满足于单一平台的观看体验，聚合型平台如茄子视频应运而生。通过整合多个视频源，为用户提供一站式的视频浏览体验，这种模式正获得越来越多用户的青睐。</p>

<p>总的来说，2026年的在线视频行业机遇与挑战并存。只有真正理解用户需求、持续创新的平台，才能在激烈的市场竞争中站稳脚跟。</p>`,
    author: '视频观察员',
    publishDate: '2026-07-30',
    category: 'industry',
    tags: ['行业分析', '视频趋势', '2026', '深度'],
    readTime: 8,
  },
  {
    id: 'a002',
    title: '广场舞的养生之道：科学研究证实跳舞有益身心健康',
    cover: 'https://readdy.ai/api/search-image?query=A%20group%20of%20happy%20elderly%20people%20dancing%20in%20a%20sunny%20park%2C%20colorful%20clothing%2C%20green%20trees%20and%20flowers%2C%20joyful%20expressions%2C%20healthy%20lifestyle%2C%20bright%20natural%20lighting%2C%20warm%20and%20uplifting%20atmosphere&width=1200&height=600&seq=article-cover-002&orientation=landscape',
    excerpt: '越来越多的科学研究表明，定期跳广场舞不仅能锻炼身体，还能改善心理健康，延缓认知衰退。让我们一起看看广场舞的神奇养生功效。',
    content: `<p>近年来，广场舞作为一项深受中老年人喜爱的群体运动，其健康益处越来越受到科学界的关注。多项研究表明，定期参与广场舞活动对身心健康有着显著的积极影响。</p>

<h2>一、心血管健康的守护者</h2>
<p>中国医学科学院的一项研究表明，每周坚持跳广场舞3-5次、每次30-60分钟的参与者，其心血管功能指标明显优于不运动的同龄人。跳舞过程中的有氧运动能够有效改善心肺功能，降低高血压和心脏病的风险。</p>

<h2>二、骨骼肌肉系统的强化</h2>
<p>广场舞的动作设计通常包含全身各部位的协调运动，对于预防骨质疏松、增强肌肉力量有着显著效果。特别是对于绝经后女性，规律的广场舞运动可以减缓骨密度下降的速度。</p>

<h2>三、认知功能的有效维护</h2>
<p>跳舞需要记住动作顺序、配合音乐节奏，这种多重认知任务的组合对大脑是一种极好的锻炼。研究发现，长期跳广场舞的老年人，其认知功能衰退的速度比不跳舞的同龄人慢30%以上。</p>

<h2>四、心理健康的良药</h2>
<p>广场舞的社交属性不容忽视。在集体活动中建立的人际关系、获得的归属感和成就感，对于预防老年抑郁和孤独感有着重要作用。许多参与者表示，跳舞让他们的生活更加充实和快乐。</p>

<h2>五、科学跳舞的建议</h2>
<p>虽然广场舞益处多多，但也需要注意科学运动。建议选择平坦的场地，穿着合适的运动鞋，根据自身体力合理安排运动强度，避免过度疲劳。</p>

<p>让我们一起舞动起来，拥抱健康快乐的晚年生活！</p>`,
    author: '健康生活编辑',
    publishDate: '2026-07-28',
    category: 'health',
    tags: ['广场舞', '养生', '健康', '科普'],
    readTime: 6,
  },
  {
    id: 'a003',
    title: 'Python入门指南：2026年最值得学习的编程语言',
    cover: 'https://readdy.ai/api/search-image?query=Clean%20and%20modern%20programming%20workspace%20with%20laptop%20showing%20Python%20code%2C%20books%20about%20programming%20on%20desk%2C%20minimal%20setup%2C%20warm%20natural%20light%2C%20inspiring%20learning%20environment%2C%20friendly%20and%20approachable%20aesthetic&width=1200&height=600&seq=article-cover-003&orientation=landscape',
    excerpt: 'Python连续多年蝉联最受欢迎编程语言榜首。无论你是零基础的编程小白，还是想拓展技能的在职人士，Python都是最佳选择。',
    content: `<p>在2026年的编程语言排行榜上，Python继续稳居榜首。它简洁优雅的语法、强大的生态系统和广泛的应用场景，使其成为初学者和专业人士的共同选择。</p>

<h2>一、为什么选择Python？</h2>
<p>Python最大的优势在于其简洁性和可读性。相比其他编程语言，Python的语法更接近自然语言，学习曲线平缓，非常适合零基础入门。同时，Python在人工智能、数据分析、Web开发等领域都有着广泛应用，学习后就业前景广阔。</p>

<h2>二、Python学习路径</h2>
<p>对于初学者，建议按照以下路径循序渐进：</p>
<p>1. Python基础语法（变量、数据类型、条件判断、循环）<br/>
2. 函数和模块的使用<br/>
3. 面向对象编程基础<br/>
4. 常用标准库（os、datetime、json等）<br/>
5. 选择一个方向深入学习（Web开发/数据分析/AI）</p>

<h2>三、必备学习资源</h2>
<p>在茄子视频的小蓝视频频道，我们为你准备了从零开始的Python全栈开发系列教程。配合在线编程平台实战练习，学习效果事半功倍。</p>

<h2>四、Python就业前景</h2>
<p>2026年，Python开发者的平均薪资持续走高。无论是在互联网公司、金融机构还是科研院所，Python人才都供不应求。特别是AI方向的Python工程师，更是各大企业争抢的热门人选。</p>

<p>现在就开始你的Python学习之旅吧！</p>`,
    author: '技术专栏',
    publishDate: '2026-07-25',
    category: 'tech',
    tags: ['Python', '编程', '入门', '教程'],
    readTime: 7,
  },
  {
    id: 'a004',
    title: '云南美食文化探秘：过桥米线的百年传奇',
    cover: 'https://readdy.ai/api/search-image?query=Authentic%20Yunnan%20crossing-bridge%20rice%20noodles%20in%20a%20traditional%20ceramic%20bowl%20with%20various%20side%20dishes%2C%20steaming%20hot%20broth%2C%20wooden%20table%2C%20warm%20lighting%2C%20traditional%20Chinese%20dining%20aesthetic%2C%20rich%20textures%20and%20colors&width=1200&height=600&seq=article-cover-004&orientation=landscape',
    excerpt: '过桥米线是云南最具代表性的美食之一，它不仅是一道菜，更承载着百年历史文化和一段温馨感人的爱情故事。',
    content: `<p>在云南，有一道家喻户晓的美食——过桥米线。它不仅以其独特的吃法和鲜美的味道征服了无数食客，背后更有着一段流传百年的动人传说。</p>

<h2>一、过桥米线的传说</h2>
<p>相传清朝时期，云南蒙自有一位秀才在湖心岛上读书，他的妻子每天都要经过一座长桥给他送饭。由于路途遥远，饭菜送到时往往已经凉了。聪明的妻子发现，鸡汤表面覆盖的一层油可以保温，于是她将滚烫的鸡汤和米线、配料分开盛放，到了岛上再将配料放入热汤中烫熟。这样，秀才就能吃到热腾腾的米线了。</p>

<h2>二、正宗的过桥米线怎么做？</h2>
<p>一碗正宗的过桥米线，关键在于汤底和配料。汤底需要用老母鸡、火腿、猪骨等文火熬制数小时，汤色清澈但味道浓郁。配料通常包括：</p>
<p>- 薄如蝉翼的生肉片<br/>
- 新鲜蔬菜（韭菜、豆芽、香菜）<br/>
- 鹌鹑蛋或鸡蛋<br/>
- 豆腐皮、木耳等</p>

<h2>三、正确的品尝方式</h2>
<p>吃过桥米线也有讲究：先将生肉片放入滚烫的汤中涮熟，再依次放入蔬菜和米线，最后打入鹌鹑蛋。等待片刻，一碗鲜香四溢的过桥米线就可以享用了。</p>

<h2>四、过桥米线的文化意义</h2>
<p>2008年，过桥米线被列入国家级非物质文化遗产名录。它不仅代表了云南的饮食文化，更象征着中国传统文化中夫妻恩爱、相濡以沫的美好品德。</p>

<p>下次来云南旅游，一定不要错过这道充满故事的美食！</p>`,
    author: '美食探索者',
    publishDate: '2026-07-22',
    category: 'food',
    tags: ['美食', '云南', '过桥米线', '文化'],
    readTime: 5,
  },
  {
    id: 'a005',
    title: '2026年暑期档电视剧推荐：十部必看高分好剧',
    cover: 'https://readdy.ai/api/search-image?query=A%20cozy%20home%20theater%20setup%20with%20large%20TV%20screen%20showing%20a%20dramatic%20scene%2C%20popcorn%20and%20drinks%20on%20coffee%20table%2C%20dim%20warm%20lighting%2C%20comfortable%20sofa%2C%20movie%20night%20atmosphere%2C%20cinematic%20home%20entertainment&width=1200&height=600&seq=article-cover-005&orientation=landscape',
    excerpt: '暑期档好剧扎堆上线，面对琳琅满目的选择，我们为你精选了十部2026年暑期必看的高分电视剧，总有一部适合你！',
    content: `<p>2026年的暑期档可谓是神仙打架，各大平台纷纷推出重磅剧集。为了让剧迷们不迷路，我们精心整理了十部口碑与热度齐飞的好剧，陪你度过炎炎夏日。</p>

<h2>一、《狂飙》未删减版</h2>
<p>年度现象级扫黑剧，张译、张颂文的精湛演技让人拍案叫绝。未删减版增加了更多细节和深度，更加震撼人心。</p>

<h2>二、《长安十二时辰》全集</h2>
<p>改编自马伯庸同名小说，精良的制作、紧凑的剧情、出色的演技，让这部古装悬疑剧成为近年来的标杆之作。</p>

<h2>三、《三体》第二季</h2>
<p>中国科幻剧的里程碑之作，第二季延续了第一季的高水准制作，剧情更加宏大震撼，科幻迷们绝对不能错过。</p>

<h2>四、《漫长的季节》</h2>
<p>一部关于东北老工业基地的温情故事，范伟的表演让人笑中带泪。这部剧证明了好的故事不需要流量明星也能打动人心。</p>

<h2>五、《去有风的地方》</h2>
<p>刘亦菲主演的治愈系作品，大理的美景配上温暖的故事，是夏日里的一股清流。</p>

<p>以上好剧在茄子视频丝瓜视频频道均可观看，快来开启你的追剧之旅吧！</p>`,
    author: '追剧达人',
    publishDate: '2026-07-20',
    category: 'entertainment',
    tags: ['电视剧', '推荐', '暑期档', '高分'],
    readTime: 5,
  },
  {
    id: 'a006',
    title: '探索深海世界：人类对海洋的了解还不到5%',
    cover: 'https://readdy.ai/api/search-image?query=Mysterious%20deep%20ocean%20with%20bioluminescent%20creatures%2C%20dark%20blue%20water%2C%20ethereal%20glow%20from%20deep-sea%20organisms%2C%20submarine%20exploring%20the%20abyss%2C%20breathtaking%20underwater%20documentary%20style%2C%20scientific%20exploration%20aesthetic&width=1200&height=600&seq=article-cover-006&orientation=landscape',
    excerpt: '海洋覆盖了地球表面的71%，但人类对深海世界的了解还非常有限。科学家估计，超过95%的海洋区域仍未被探索。',
    content: `<p>当我们仰望星空，惊叹于宇宙的浩瀚时，很少有人意识到，地球上最大的未知领域就在我们脚下——深海。</p>

<h2>一、海洋：地球最后的边疆</h2>
<p>海洋覆盖了地球表面的71%，平均深度约为3688米。然而，人类只探索了不到5%的海洋区域。相比之下，我们对月球表面的了解可能比深海还要多。</p>

<h2>二、深海的神奇生物</h2>
<p>在完全没有阳光的深海环境中，生物进化出了令人惊叹的生存策略。有的生物能够自体发光，有的则拥有透明的身体，还有的能够在极端压力和温度下生存。</p>

<h2>三、深海探索的挑战</h2>
<p>深海探索面临的主要挑战是巨大的水压。在10000米深的海沟中，压力相当于1000个大气压，这对任何探测器来说都是严峻考验。此外，完全黑暗的环境、极低的温度也给探索增加了难度。</p>

<h2>四、保护海洋的重要性</h2>
<p>海洋不仅是无数生物的家园，更是地球气候系统的重要组成部分。保护海洋生态环境，就是保护人类自己的未来。</p>

<p>在茄子视频的蓝莓视频频道，你可以观看更多精彩的海洋纪录片，一起探索深蓝之下的未知世界。</p>`,
    author: '自然探索者',
    publishDate: '2026-07-18',
    category: 'nature',
    tags: ['海洋', '探索', '自然', '科普'],
    readTime: 6,
  },
];

export function getArticleById(id: string): Article | undefined {
  return articles.find((a) => a.id === id);
}

export function getRelatedArticles(id: string, limit: number = 3): Article[] {
  const current = getArticleById(id);
  if (!current) return articles.slice(0, limit);
  return articles.filter((a) => a.category === current.category && a.id !== id).slice(0, limit);
}

export function getLatestArticles(limit: number = 6): Article[] {
  return [...articles].sort((a, b) => b.publishDate.localeCompare(a.publishDate)).slice(0, limit);
}